// extracted by mini-css-extract-plugin
export var container = "Footer-module--container--0c9rU";
export var copyright = "Footer-module--copyright--v7mXx";